import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Paper, Tooltip, Typography } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import UnoButton from "../../utils/UnoButton";
import { unoTheme } from "../../../assets/styles/unoTheme";
import MySwitch from '../../utils/MySwitch';

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//API
import { UserAPI } from "../../../API/user";
import { CertificationAPI } from "../../../API/certification";

//MyInputs
import MyTextField from "../../utils/MyTextField";
import MySelect from "../../utils/MySelect";
import MyDatePicker from "../../utils/MyDatePicker";

import moment from "moment";

import CircularProgress from '@material-ui/core/CircularProgress';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import _ from 'lodash';

import { isValidEmail, isValidCpf, justNumbers, applyMaskPhone, getConsultingId } from "../../utils/utils";

import ConfirmActionRightContent from './ConfirmActionRightContent'


const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(5)
    },

    main: {
        //Ocupa o que sobra abaixo do header; minHeight 0 permite encolher e deixar o formBody rolar
        flex: 1,
        minHeight: 0,
        paddingBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        textAlign: 'left',

        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }

    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    detailRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

    },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    warning: {
        color: unoTheme.warningColor
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    selectable: {
        '& input': {

            cursor: 'pointer',
            color: unoTheme.mainColor,
        }
    },
    //Só os campos rolam: header e botões continuam visíveis
    formBody: {
        flex: '0 1 auto',
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        //Sem isso as linhas do grid se esticam para preencher a altura disponível
        alignContent: 'flex-start',
    },

    sectionTitle: {
        fontSize: '14px',
        fontWeight: '600',
        color: unoTheme.defaultTextColor,
    },


}));

export default function NewClientManager(props) {

    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)

    const dispatch = useDispatch();

    //const clientOn = useSelector(state => state.clientOn)

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);

    const [confirmingAction, setConfirmingAction] = useState(false);

    //form    
    const [submitted, setSubmitted] = useState(false);

    const [passwordReseted, setPasswordReseted] = useState(false);

    const [clientOnScreen, setClientOnScreen] = useState({});

    const [inputNameManager, setInputNameManager] = useState("");
    const [inputIsResourceManager, setInputIsResourceManager] = useState(false);
    const [inputEmailManager, setInputEmailManager] = useState("");
    const [inputCpfManager, setInputCpfManager] = useState("");
    const [inputPhoneManager, setInputPhoneManager] = useState("");
    const [inputPasswordManager, setInputPasswordManager] = useState("");

    //Dados opcionais do gestor de recursos
    const [certifications, setCertifications] = useState([]);
    const [inputPosition, setInputPosition] = useState("");
    const [inputCertificationEntityId, setInputCertificationEntityId] = useState("");
    const [inputCertificationId, setInputCertificationId] = useState("");
    const [inputCertificationValidity, setInputCertificationValidity] = useState(null);

    //As entidades saem da própria lista de certificações (que já vem com o join em certification_entitys)
    const certificationEntities = useMemo(() => _.uniqBy(certifications, 'certification_entity_id'), [certifications]);

    const entityCertifications = useMemo(() => certifications.filter(
        (certification) => certification.certification_entity_id == inputCertificationEntityId
    ), [certifications, inputCertificationEntityId]);

    const invalidCertificationValidity = inputIsResourceManager
        && inputCertificationValidity != null
        && !inputCertificationValidity.isValid();

    const changeIsResourceManager = (event) => {
        setInputIsResourceManager(event.target.checked);
    };

    function changeCertificationEntity(entityId) {
        setInputCertificationEntityId(entityId);
        setInputCertificationId("");
        setInputCertificationValidity(null);
    }

    function changeCertification(certificationId) {
        setInputCertificationId(certificationId);
        if (!certificationId) {
            setInputCertificationValidity(null);
        }
    }

    async function doSaveManager(event) {

        event.preventDefault();
        setSubmitted(true);

        setOpenBackdrop(true);

        let user = {
            cpf: inputCpfManager,
            password: content.update ? (passwordReseted ? inputPasswordManager : null) : inputPasswordManager,
            name: inputNameManager,
            email: inputEmailManager,
            phone_number: justNumbers(inputPhoneManager),
            role: 3,
            is_resource_manager: inputIsResourceManager,
            //Deixando de ser gestor de recursos os dados de certificação são limpos
            position: inputIsResourceManager && inputPosition ? inputPosition : null,
            certification_id: inputIsResourceManager && inputCertificationId ? Number(inputCertificationId) : null,
            certification_validity: inputIsResourceManager && inputCertificationId
                && inputCertificationValidity && inputCertificationValidity.isValid() ?
                inputCertificationValidity.format('YYYY-MM-DD') : null,
            client_id: clientOnScreen.id, //managers sempre possuem o cliente
            consulting_id: getConsultingId(currentUser)
        }

        if (invalidCertificationValidity) {
            setOpenBackdrop(false);
            return;
        }

        if (content.update) {

            if (isValidCpf(justNumbers(user.cpf))
                &&
                (
                    (passwordReseted && user.password != "" && user.password.length >= 6)
                    ||
                    (!passwordReseted)
                )
                && user.name != ""
                && isValidEmail(user.email)) {

                setSubmitted(false);

                let response = await UserAPI.updateUser(content.data.id, user);

                if (response.success) {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'success',
                        message: "Gestor atualizado com sucesso"

                    }));

                    dispatch(allActions.rightContentActions.update())

                } else {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: "Erro ao atualizar o gestor: " + response.body.message

                    }));
                }
            }

        } else {

            if (isValidCpf(justNumbers(user.cpf))
                && user.password != ""
                && user.password.length >= 6
                && user.name != ""
                && isValidEmail(user.email)) {

                setSubmitted(false);

                let response = await UserAPI.create(user);

                if (response.success) {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'success',
                        message: "Gestor cadastrado com sucesso"

                    }));

                    dispatch(allActions.rightContentActions.update())

                } else {

                    dispatch(allActions.fullLoadActions.setFullLoad({
                        show: false,
                    }))

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: "Erro ao cadastrar o gestor: " + response.body.message

                    }));
                }

            }
        }

        setOpenBackdrop(false);
    }

    function initForm(manager, certificationOptions) {

        setInputNameManager(manager.name);
        setInputEmailManager(manager.email);
        setInputCpfManager(manager.cpf);
        setInputPhoneManager(applyMaskPhone(manager.phone_number));
        setInputIsResourceManager(manager.is_resource_manager);

        setInputPosition(manager.position || "");

        const certification = certificationOptions.find((row) => row.id == manager.certification_id);
        if (certification) {
            setInputCertificationEntityId(String(certification.certification_entity_id));
            setInputCertificationId(String(certification.id));
            setInputCertificationValidity(manager.certification_validity ? moment.utc(manager.certification_validity) : null);
        }

    }

    async function loadForm() {

        const responseCerts = await CertificationAPI.getAllCertifications();
        const certificationOptions = responseCerts.success ? responseCerts.body.rows : [];
        setCertifications(certificationOptions);

        if (content.update) {
            initForm(content.data, certificationOptions);
        }
    }

    async function doDeleteManager() {

        setOpenBackdrop(true)

        //content contem data que contem a conta que foi aberta no componente lateral
        const response = await UserAPI.deleteUser(content.data.id);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Gestor excluído com sucesso!'
            }))

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Erro ao excluir gestor: " + response.body.message
            }))
        }

        setOpenBackdrop(false)
        dispatch(allActions.rightContentActions.update());

    }

    //deleção da conta
    function handleCancel() {
        setConfirmingAction(false);
    }

    function handleConfirm() {
        doDeleteManager();
    }

    useEffect(() => {

        //Caso seja a edição de um manager
        if (content) {

            console.log("CONTENT: ", content);

            //Setando o cliente que está sendo utilizado, selecionado
            setClientOnScreen(content.clientOnScreen);
            loadForm();
        }


    }, []);

    const passwordDisabled = useMemo(() => content.update && !passwordReseted, [content, passwordReseted]);

    return (
        <div className={classes.root}>

            {
                !confirmingAction ?

                    <>
                        <div className={classes.header}>
                            <IconButton
                                className={!content.update ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <ArrowBackIcon />
                            </IconButton>


                            <div>
                                <Typography
                                    variant={'h6'}
                                    align={'center'}>

                                    {content.update ? "Editar Gestor" : "Cadastrar Gestor"}

                                </Typography>

                                <Typography
                                    variant={'body1'}
                                    align={'center'}
                                    style={{ color: unoTheme.defaultTextColor }}>

                                    {clientOnScreen && (clientOnScreen.city_name + " - " + clientOnScreen.uf)}

                                </Typography>

                            </div>


                            <IconButton className={content.update ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <CloseIcon />
                            </IconButton>

                        </div>


                        <div className={classes.main}>

                            <Grid container spacing={2} className={classes.formBody}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <MyTextField required
                                        outerlabel="Nome"
                                        size={'small'}
                                        validator={inputNameManager == "" && submitted ? true : undefined}
                                        variant="outlined"
                                        onChange={(value) => setInputNameManager(value)}
                                        helperText={"Insira um nome"}
                                        placeholder={'Insira o nome'}
                                        value={inputNameManager} />
                                </Grid>

                                <Grid item xs={12} sm={7} md={7}>
                                    <MyTextField
                                        value={inputEmailManager}
                                        variant="outlined"
                                        size={'small'}
                                        onChange={(value) => setInputEmailManager(value)}
                                        validator={!isValidEmail(inputEmailManager) && submitted ? true : undefined}
                                        helperText={"Insira um email válido"}
                                        placeholder={'Insira o email'}
                                        outerlabel="Email" />
                                </Grid>

                                <Grid item xs={12} sm={5} md={5}>
                                    <MyTextField
                                        value={inputPhoneManager}
                                        size={'small'}
                                        onChange={(value) => setInputPhoneManager(value)}
                                        mask={['phone']}
                                        variant="outlined"
                                        placeholder={'Insira o telefone'}
                                        outerlabel="Telefone" />
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>
                                    <MyTextField
                                        value={inputCpfManager}
                                        onChange={(value) => setInputCpfManager(value)}
                                        size={'small'}
                                        variant="outlined"
                                        validator={!isValidCpf(inputCpfManager) && submitted ? true : undefined}
                                        helperText={"Insira um CPF válido"}
                                        mask={['cpf']}
                                        placeholder={'Insira o CPF'}
                                        outerlabel="CPF" />
                                </Grid>

                                <Grid item xs={12} sm={6} md={6}>

                                    <MyTextField
                                        type="password"                                        // disabled={!passwordReseted && content.update}
                                        className={passwordDisabled ? classes.selectable : ''}
                                        outerlabel="Senha"
                                        value={inputPasswordManager}
                                        onChange={(value) => setInputPasswordManager(value)}
                                        size={'small'}
                                        variant="outlined"
                                        onClick={() => setPasswordReseted(true)}
                                        placeholder={!passwordReseted && content.update ? "Clique para nova senha" : "Insira a senha"}
                                        validator={inputPasswordManager.length < 6
                                            && submitted ? true : undefined}
                                        helperText={"Insira uma senha de 6 dígitos"}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <MySwitch
                                        direction="horizontal"
                                        outerlabel={'Gestor de Recursos?'}
                                        checked={inputIsResourceManager}
                                        onChange={changeIsResourceManager}
                                        color="primary" />
                                </Grid>

                                {
                                    inputIsResourceManager ?
                                        <>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <Divider />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12}>
                                                <Typography className={classes.sectionTitle}>
                                                    {'Gestor de Recursos (opcional)'}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12}>
                                                <MyTextField
                                                    outerlabel="Cargo"
                                                    size={'small'}
                                                    variant="outlined"
                                                    onChange={(value) => setInputPosition(value)}
                                                    placeholder={'Insira o cargo'}
                                                    value={inputPosition} />
                                            </Grid>

                                            <Grid item xs={12} sm={5} md={5}>
                                                <MySelect
                                                    outerlabel={'Entidade certificadora'}
                                                    value={inputCertificationEntityId}
                                                    onChange={(e) => changeCertificationEntity(e.target.value)}
                                                    options={[
                                                        <option key={'cert-entity-none'} value={''}>{'Selecione...'}</option>,
                                                        ...certificationEntities.map((row) => (
                                                            <option key={'cert-entity-' + row.certification_entity_id}
                                                                value={String(row.certification_entity_id)}>{row.entity}</option>
                                                        ))
                                                    ]} />
                                            </Grid>

                                            <Grid item xs={12} sm={7} md={7}>
                                                <MySelect
                                                    outerlabel={'Certificação'}
                                                    disabled={!inputCertificationEntityId}
                                                    value={inputCertificationId}
                                                    onChange={(e) => changeCertification(e.target.value)}
                                                    options={[
                                                        <option key={'cert-none'} value={''}>{'Selecione...'}</option>,
                                                        ...entityCertifications.map((row) => (
                                                            <option key={'cert-' + row.id} value={String(row.id)}>{row.name}</option>
                                                        ))
                                                    ]} />
                                            </Grid>

                                            <Grid item xs={12} sm={5} md={5}>
                                                <MyDatePicker
                                                    disabled={!inputCertificationId}
                                                    margin="dense"
                                                    outerlabel="Validade"
                                                    format="DD/MM/YYYY"
                                                    value={inputCertificationValidity}
                                                    validator={invalidCertificationValidity && submitted ? true : undefined}
                                                    helperText={"Informe uma data válida"}
                                                    onChange={(date) => setInputCertificationValidity(date)} />
                                            </Grid>
                                        </>
                                        : null
                                }

                            </Grid>

                            <br />
                            <br />
                            <div className={classes.bottom}>

                                <div className={'bottomButtons'}>

                                    <UnoButton
                                        className={
                                            !content.update ? classes.hiddenIcon : null}
                                        onClick={() => setConfirmingAction(true)}
                                        type='errorClean'>
                                        {"Excluir gestor"}
                                    </UnoButton>

                                    <UnoButton
                                        onClick={(e) => doSaveManager(e)}
                                        type={content.update ? 'success' : 'primary'}>
                                        {content.update ? "Atualizar Gestor" : "Salvar Gestor"}
                                    </UnoButton>
                                </div>

                            </div>

                        </div>
                    </>

                    :

                    <ConfirmActionRightContent
                        message={`Tem certeza que quer excluir 
                        o usuário ${content && content.data ? content.data.name : ''}?`}
                        handleCancel={handleCancel}
                        handleConfirm={handleConfirm}
                    />

            }




            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }


        </div>
    );
}



